import {
   CHANGE_COLOR,
   CLEAR_DRAW,
} from './types';

export function changeColor(color,color1,color2) {
    return {
        type: CHANGE_COLOR,
        payload: {color:color,color1:color1,color2:color2, clear:false},
    };
}
export function clearDraw(color,color1,color2) {
    return {
        type: CLEAR_DRAW,
        payload: {color:color,color1:color1,color2:color2, clear:true},
    };
}



// WEBPACK FOOTER //
// ./src/app/actions/ts_overlay_actions.js